<template >
  <div class="productwxH5" ref="productwxH5">
    <div class="wx-header">
      <div class="wh-tit">自助收银</div>
      <div class="wh-tip">
        为解决自助收银场景而研发的一款收银系统。自助收银系统视觉效果美观，功能设计完善，收银操作简单，可以给顾客带来更流畅、更简便的自助体验。
      </div>
      <div class="wh-btn" @click.stop="clickdownloadBySelf">立即下载</div>
    </div>
    <div class="wx-introduce">
      <img class="wi-img" src="@/assets/newdownload/pint.png" alt="" />
      <div class="wi-row top">
        <div class="wir-item">
          <div class="wiri-top">
            <img
              class="wirit-img"
              src="@/assets/newdownload/prow3.png"
              alt=""
            />
            <div class="wirit-word">高效率</div>
          </div>
          <div class="wiri-bottom">减少排队等待时间</div>
        </div>
        <div class="wir-item">
          <div class="wiri-top">
            <img
              class="wirit-img"
              src="@/assets/newdownload/prow1.png"
              alt=""
            />
            <div class="wirit-word">好体验</div>
          </div>
          <div class="wiri-bottom">安全识别，快速支付</div>
        </div>
      </div>
      <div class="wi-row">
        <div class="wir-item">
          <div class="wiri-top">
            <img
              class="wirit-img"
              src="@/assets/newdownload/prow3.png"
              alt=""
            />
            <div class="wirit-word">降成本、省人力</div>
          </div>
          <div class="wiri-bottom">节省≥30%人力物力</div>
        </div>
        <div class="wir-item">
          <div class="wiri-top">
            <img
              class="wirit-img"
              src="@/assets/newdownload/prow1.png"
              alt=""
            />
            <div class="wirit-word">易安装</div>
          </div>
          <div class="wiri-bottom">兼容性强，无需改造</div>
        </div>
      </div>
    </div>
    <div class="wx-process">
      <div class="wp-tit">自助购流程</div>
      <div class="wp-item top">
        <div class="wpi-num"><span class="word">1</span></div>
        <div class="wpi-tit">会员登录</div>
        <div class="wpi-tip">会员可先进行登录</div>
      </div>
      <img src="@/assets/newdownload/wparrow.png" alt="" class="wp-arrow" />
      <div class="wp-item">
        <div class="wpi-num"><span class="word">2</span></div>
        <div class="wpi-tit">扫描商品条码</div>
        <div class="wpi-tip">将商品条码对准扫描口进行扫描</div>
      </div>
      <img src="@/assets/newdownload/wparrow.png" alt="" class="wp-arrow" />
      <div class="wp-item">
        <div class="wpi-num"><span class="word">3</span></div>
        <div class="wpi-tit">结算</div>
        <div class="wpi-tip">用户自行选择付款方式进行付款</div>
      </div>
      <img src="@/assets/newdownload/wparrow.png" alt="" class="wp-arrow" />
      <div class="wp-item">
        <div class="wpi-num"><span class="word">4</span></div>
        <div class="wpi-tit">拿取小票</div>
        <div class="wpi-tip">付款成功后等待小票打印</div>
      </div>
    </div>
    <div class="wx-payway">
      <div class="wxp-tit">多种付款方式选择</div>
      <div class="wxp-row">
        <div class="wxpr-item">
          <img
            src="@/assets/newdownload/payway1.png"
            alt=""
            class="wxpri-img"
          />
          <div class="wxpri-tit">微信刷脸</div>
        </div>
        <div class="wxpr-item">
          <img
            src="@/assets/newdownload/payway2.png"
            alt=""
            class="wxpri-img"
          />
          <div class="wxpri-tit">付款码支付</div>
        </div>
      </div>
      <div class="wxp-row top">
        <div class="wxpr-item">
          <img
            src="@/assets/newdownload/payway3.png"
            alt=""
            class="wxpri-img"
          />
          <div class="wxpri-tit">余额支付</div>
        </div>
        <div class="wxpr-item">
          <img
            src="@/assets/newdownload/payway4.png"
            alt=""
            class="wxpri-img"
          />
          <div class="wxpri-tit">扫码支付</div>
        </div>
      </div>
    </div>
    <div class="wx-system">
      <div class="ws-tit">系统配置</div>
      <div class="ws-item">
        <div class="wsi-top">
          <div class="wsi-tit">小票设置</div>
          <img src="@/assets/newdownload/wsii1.png" alt="" class="wsi-img" />
        </div>
        <div class="wsi-bottom">
          商家可自行设置是否打印小票、打印数量、尺寸。
        </div>
      </div>
      <div class="ws-item">
        <div class="wsi-top">
          <div class="wsi-tit">刷脸支付设置</div>
          <img src="@/assets/newdownload/wsii2.png" alt="" class="wsi-img" />
        </div>
        <div class="wsi-bottom">商家可自行设置是否开启微信刷脸支付功能。</div>
      </div>
      <div class="ws-item">
        <div class="wsi-top">
          <div class="wsi-tit">语音播报设置</div>
          <img src="@/assets/newdownload/wsii3.png" alt="" class="wsi-img" />
        </div>
        <div class="wsi-bottom">
          商家可自行设置是否打开启语音播报，以及设置语音播报的内容。
        </div>
      </div>
      <div class="ws-item bottom">
        <div class="wsi-top">
          <div class="wsi-tit">一键同步数据</div>
          <img src="@/assets/newdownload/wsii4.png" alt="" class="wsi-img" />
        </div>
        <div class="wsi-bottom">
          丰派自助收银配备一键同步数据功能，商家无需逐一导入商品数据。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  activated() {
    this.$refs.productwxH5.scrollIntoView();
  },
  methods: {
    clickdownloadBySelf() {
      let elink = document.createElement("a");
      elink.download = "自助收银版本下载";
      elink.style.display = "none";
      elink.href = "https://www.ld8848.cn/fp_pos_auto/fp_pos_auto.apk";
      elink.target = "_self";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
  },
};
</script>

<style lang="less" scoped>
.productwxH5 {
  width: 750px;
}
.wx-header {
  width: 750px;
  height: 790.24px;
  background: #e1f1fc;
  background: url("~@/assets/newdownload/productbg1.png");
  background-size: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .wh-tit {
    margin-top: 80px;
    font-weight: 500;
    font-size: 64px;
    line-height: 80px;
    color: #1f2329;
  }
  .wh-tip {
    margin-top: 42px;
    width: 620px;
    font-weight: 400;
    font-size: 28px;
    line-height: 40px;
    color: #1f2329;
  }
  .wh-btn {
    margin-top: 42px;
    width: 212px;
    height: 64px;
    background: #2f54eb;
    box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
    border-radius: 6px;
    font-weight: 400;
    font-size: 32px;
    line-height: 64px;
    color: #ffffff;
    text-align: center;
    margin-bottom: 43px;
    &:active {
      background: #5c8cff;
    }
  }
}
.wx-introduce {
  width: 750px;
  height: 502px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  .wi-img {
    width: 660px;
    height: 460px;
    position: absolute;
    top: -300px;
  }
  .wi-row {
    margin-top: 50px;
    display: flex;
    align-items: center;
    gap: 86px;
    &.top {
      margin-top: 229px;
    }
    .wir-item {
      width: 262px;
      height: 82px;
      .wiri-top {
        display: flex;
        align-items: center;
        .wirit-img {
          width: 28px;
          height: 28px;
        }
        .wirit-word {
          margin-left: 10px;
          font-weight: 400;
          font-size: 28px;
          line-height: 36px;
          color: #2d3c50;
        }
      }
      .wiri-bottom {
        margin-top: 10px;
        margin-left: 38px;
      }
    }
  }
}
.wx-process {
  width: 750px;
  height: 895px;
  background: url("~@/assets/newdownload/wxpbg.png");
  background-size: 100%;
  background-repeat: no-repeat;
  background-position-y: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .wp-tit {
    margin-top: 40px;
    font-weight: 500;
    font-size: 40px;
    line-height: 48px;
    color: #292929;
  }
  .wp-item {
    width: 600px;
    height: 114px;
    padding: 16px 20px;
    border: 2px solid #455770;
    border-radius: 9px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    overflow: hidden;
    &.top {
      margin-top: 50px;
    }
    .wpi-num {
      position: absolute;
      width: 100px;
      height: 100px;
      top: -60px;
      left: -60px;
      background: #2d3c50;
      border-radius: 50px;
      .word {
        position: absolute;
        bottom: 16px;
        right: 20px;
        font-size: 24px;
        line-height: 24px;
        text-align: right;
        color: #ffffff;
      }
    }
    .wpi-tit {
      font-weight: 400;
      font-size: 28px;
      line-height: 36px;
      color: #2d3c50;
    }
    .wpi-tip {
      margin-top: 10px;
      font-weight: 400;
      font-size: 28px;
      line-height: 36px;
      color: #2d3c50;
    }
  }
  .wp-arrow {
    margin: 24px 0;
    width: 32px;
    height: 39px;
  }
}
.wx-payway {
  width: 750px;
  height: 844px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  .wxp-tit {
    margin: 64px 0 50px;
    font-weight: 500;
    font-size: 40px;
    line-height: 48px;
    color: #292929;
  }
  .wxp-row {
    display: flex;
    align-items: center;
    // width: 272px;
    // height: 272px;
    gap: 50px;
    &.top {
      margin-top: 50px;
    }
    .wxpri-img {
      width: 272px;
      height: 272px;
    }
    .wxpri-tit {
      font-weight: 400;
      font-size: 28px;
      line-height: 36px;
      text-align: center;
      color: #292929;
    }
  }
}
.wx-system {
  width: 750px;
  height: 974px;
  background: url("~@/assets/newdownload/wxsystemp.png");
  background-size: 100%;
  // background-repeat: no-repeat;
  // background-position-y: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .ws-tit {
    margin: 64px 0 50px;
    font-weight: 500;
    font-size: 40px;
    line-height: 48px;
    color: #292929;
  }
  .ws-item {
    width: 640px;
    // height: 160px;
    padding: 30px 0px;
    border-bottom: 1px solid rgba(45, 60, 80, 0.5);
    display: flex;
    flex-direction: column;
    &.bottom {
      border: none;
    }
    .wsi-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .wsi-tit {
        font-weight: 400;
        font-size: 32px;
        line-height: 40px;
        color: #2d3c50;
      }
      .wsi-img {
        width: 54px;
        height: 54px;
      }
    }
    .wsi-bottom {
      margin-top: 17px;
      font-weight: 400;
      font-size: 28px;
      line-height: 36px;
      color: #2d3c50;
    }
  }
  .ws-item + .ws-item {
    margin-top: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/h5/productautoH5.vue